import { object, string } from 'yup';
import { ValidationSchema } from 'enums/CreateSupplierModalEnums';
import { CountryCodes } from 'enums/LocationModalEnums';

export const Fields = [
  {
    id: 'supplierName',
    name: 'supplierName',
    placeholder: 'Supplier Name',
    label: 'Supplier Name',
    disabled: false,
    long: true
  },
  {
    id: 'map',
    name: 'map',
    placeholder: 'Street/Locality',
    label: 'Street/Locality',
    google: true,
    disabled: false,
  },
  {
    id: 'streetLocality',
    name: 'streetLocality',
    placeholder: 'Street/Locality',
    label: 'Street/Locality',
    google: false,
    disabled: false,
  },
  {
    id: 'city',
    name: 'city',
    placeholder: 'City',
    label: 'City',
    disabled: false,
  },
  {
    id: 'province',
    name: 'province',
    placeholder: 'Province',
    label: 'Province',
    disabled: false,
  },
  {
    id: 'country',
    name: 'country',
    placeholder: 'Country',
    label: 'Country',
    disabled: false,
  },
  {
    id: 'postalCode',
    name: 'postalCode',
    placeholder: 'Postal Code',
    label: 'Postal Code',
    disabled: false,
  },
  {
    id: 'postalCode',
    name: 'postal_code',
    placeholder: 'Postal Code',
    label: 'Postal Code',
    disabled: false,
    className: 'd-none'
  },
];

export const validationSchema = object({
  streetLocality: string().required(ValidationSchema.ERROR_MESSAGE),
  supplierName: string().required(ValidationSchema.ERROR_MESSAGE),
  city: string().required(ValidationSchema.ERROR_MESSAGE),
  province: string().when("country_code", {
    is: (value: string) => value === CountryCodes.CANADA || value === CountryCodes.USA,
    then: string().required("Required"),
    otherwise: string().notRequired(),
  }),
  country: string().required(ValidationSchema.ERROR_MESSAGE),
  postalCode: string().when("country_code", (country_code, schema) => {
    if (country_code) {
      let restrictedCountryCodeList = ['US', 'CA']
      if (restrictedCountryCodeList.includes(country_code)) {
        return schema.required(ValidationSchema.ERROR_MESSAGE)
      }
    }
    return schema
  })
});
